import {SaveCancelFooter} from '@/components/molecules'
import SalesUomsEdit from '@/containers/ProductReviewEditContainer/TaxAndSales/SalesUomsEdit/SalesUomsEdit'
import TaxesEdit from '@/containers/ProductReviewEditContainer/TaxAndSales/TaxesEdit/TaxesEdit'
import {useTaxesAndEditHook} from '@/containers/ProductReviewEditContainer/TaxAndSales/useTaxesAndEditHook'
import './taxAndSalesEdit.scss'
import {Modal} from '@/components/atoms'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {useState} from 'react'
import {setToastNotifications} from '@/store/slices/commonSlice'
import { useAppDispatch } from '@/store'

export const TaxAndSalesEdit = ({formData, setFormData, handleSave}) => {
  const [isSaving, setIsSaving] = useState(false)
  const dispatch = useAppDispatch()
  
  const {
    taxFields,
    saleUomsFields,
    handleSalesUomsInputChange,
    handleTaxInputChange,
    handleCancel,
    isCancel,
    onClickSecondaryButton,
    onClickPrimaryButton,
    saveChanges
  } = useTaxesAndEditHook({
    formData,
    setFormData,
  })
  
  const handleSaveAction = async () => {
    try {
      setIsSaving(true)
      
      // Create an updated data object with the local state values
      const updatedFormData = {
        ...formData,
        taxes: taxFields,
        saleUoms: saleUomsFields
      };

      saveChanges();
      
      await handleSave(updatedFormData);
      
    } catch (error) {
      dispatch(setToastNotifications({
        show: true,
        message: `Error saving Tax and Sales data: ${error}`,
        type: 'error',
      }))
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="brand-category-edit">
      <TaxesEdit 
        handleTaxInputChange={handleTaxInputChange} 
        taxFields={taxFields} 
      />
      <SalesUomsEdit 
        handleSalesUomsInputChange={handleSalesUomsInputChange} 
        saleUomsFields={saleUomsFields} 
      />
      {isCancel ? (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={isCancel}
          onCloseModal={handleCancel}
          title="Are you sure you want to cancel?"
          text={
            'The changes will not be saved.'
          }
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={onClickPrimaryButton}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={onClickSecondaryButton}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      ) : null}

      <SaveCancelFooter
        handleCancel={handleCancel}
        nextAction={handleSaveAction}
        isReview={true}
        hideSaveDraft={true}
        isLoading={isSaving}
      />
    </div>
  )
}
